export default __webpack_public_path__ + "assets/like-2cbfeb074097b2860be2b892eb1df827.svg";